import React from 'react';
import PropTypes from 'prop-types';

const ObjectIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 18">
        <path d="M5.7 1.2v2.1h6.6V1.2zm.6.6h2.4v.9H6.3zm5.4.9H9.3v-.9h2.4z" fill={fill} />
        <path d="M13.5 6.6V0h-9v5.7H0V18h18V6.6zM5.1.6h7.8v6h-.6V4.5H5.7v1.2h-.6zM3 17.4h-.6v-1.8H3zm1.2 0h-.6v-1.8h.6zm1.8 0H4.8V15h-3v2.4H.6V6.3H6zm.3-12.3h2.4V6H6.6v-.3h-.3zm.3 3.3h2.1v.9H6.6zm0 3.3h2.1v.9H6.6zm1.5 5.7v-2.1h.6v2.1zm1.2 0v-2.1h.6v2.1zm2.1 0h-.9v-2.7h-3v2.7h-.9v-4.2h4.8zm0-4.8H9.3v-.9h2.1zm0-1.5H6.6V9.9h4.8zm0-1.8H9.3v-.9h2.1zm0-1.5H6.6V6.6h4.8zm.3-1.8H9.3v-.9h2.4zm2.7 11.4h-.6v-.9h.6zm1.2 0H15v-.9h.6zm1.8 0h-1.2v-1.5h-3v1.5H12V7.2h5.4z" fill={fill} />
        <path d="M1.2 6.9V9h4.2V6.9zm.6.6H3v.9H1.8zm3 .9H3.6v-.9h1.2z" fill={fill} />
        <path d="M1.2 9.6v2.1h4.2V9.6zm.6.6H3v.9H1.8zm3 .9H3.6v-.9h1.2z" fill={fill} />
        <path d="M1.2 12.3v2.1h4.2v-2.1zm.6.6H3v.9H1.8zm3 .9H3.6v-.9h1.2z" fill={fill} />
        <path d="M12.6 7.8v2.1h4.2V7.8zm.6.6h1.2v.9h-1.2zm3 .9H15v-.9h1.2z" fill={fill} />
        <path d="M12.6 10.5v2.1h4.2v-2.1zm.6.6h1.2v.9h-1.2zm3 .9H15v-.9h1.2z" fill={fill} />
        <path d="M12.6 13.2v2.1h4.2v-2.1zm.6.6h1.2v.9h-1.2zm3 .9H15v-.9h1.2z" fill={fill} />
    </svg>
);

ObjectIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

ObjectIcon.defaultProps = {
    width: '18',
    height: '18',
    fill: '#4b254e'
};

export default ObjectIcon;
